import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest(action) {
    const { auditId } = action.payload;
    const url = `${config.api.paths.assetFoundElsewhere}?audit=${auditId}`;
    try {
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess([data]));
    } catch (error) {
        logToSentry("On fetching asset found elsewhere:", { error });
        console.error(error);
        yield put(actionCreators.getFailure(error));
    }
}

function* acceptRequest(action) {
    const { auditId, altAsset, expectedAsset } = action.payload;
    const url = config.api.paths.assetFoundElsewhere;
    try {
        yield call(http.authorized.post, url, {
            audit: auditId,
            altAsset,
            expectedAsset
        });
        yield put(actionCreators.acceptSuccess(auditId));
        yield put(actionCreators.getRequest(auditId));
    } catch (error) {
        logToSentry("On accepting asset found elsewhere:", { error });
        console.error(error);
        yield put(actionCreators.acceptFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.ASSET_FOUND_ELSEWHERE_GET_REQUEST, getRequest),
        takeEvery(actionTypes.ASSET_FOUND_ELSEWHERE_ACCEPT_REQUEST, acceptRequest)
    ]);
}
